module.exports = __webpack_public_path__ + "img/grey-french-door-refrigerator-3264487.a502f902.jpg";